export default __webpack_public_path__ + "static/media/gem_blue.a90167b1.png";